import styled from 'vue-styled-components'

export default styled.div`
    & .columns {
        &.center {
            display: flex;
            justify-content: center;
        }
    }
    & .header {
        display: flex;
        background-color: #002147;
        align-items: center;
        height: 70px;
        top: 0;
        z-index: 999;
        position: sticky;
        & .container-full {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            padding-left: 25px;
            padding-right: 25px;
            & .logo-img {
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }
            & .list-options{
                padding: 0;
                margin-left: auto;
                display: flex;
                align-items: center;
                list-style: none;
                & .option-item {
                    & .item-link {
                        color: #FFFFFF;
                        padding: 15px;
                        &.active {
                            font-weight: bold;
                            text-decoration: underline;
                        }
                    }
                }
            }
        }
    }
    & .container-full {
            display: flex;
            width: 100%;
            height: 100%;
            max-width: 1344px;
            margin: 0 auto;
            flex-wrap: wrap;            
    }
    & .body {
        display: flex;
        flex-wrap: wrap;
        min-height: calc(100vh - 70px);
        & .left-panel {
            background-color: #FFFFFF;
            width: calc(100% - 360px);
            @media(max-width: 900px){
                width: 100%;
                min-height: calc(100vh + 300px);
            }
            & .left-container {
                padding: 4rem 5rem;
                @media(max-width: 900px){
                    padding: 25px;
                }
                & .title {
                    margin: 0;
                    font-weight: bold;
                    font-size: 2em;
                    @media(max-width: 900px){
                        font-size: 1.6em;
                    }
                }
                & .list-options {
                    margin-top: 35px;
                    & .option-item {
                        display: flex;
                        align-items: center;
                        margin-bottom: 15px;
                        & .number {
                            background-color: #012169;
                            padding: 0 !important;
                            color: #FFFFFF;
                            width: 30px;
                            height: 40px;
                            font-size: 1.2em;
                            line-height: 1.2em;
                            font-weight: bold;
                            border-radius: 6px;
                            filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
                        }
                        & .label {
                            margin: 0;
                            margin-left: 0;
                            font-size: 1.1em;
                        }
                    }
                }
                & .form-block {
                    margin-top: 5rem;
                    border-top: 1px solid #efefef;
                    padding-top: 3rem;
                    & .title {
                        font-size: 1.3em;
                        text-align: center;
                        margin-bottom: 2rem;
                    }
                }
            }
        }
        & .right-panel {
            width: 360px;
            @media(max-width: 900px){
                width: 100%;
                border-top: 1px solid #efefef;
            }
            background-color: #FAFAFA;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            padding: 15px;
            & .image-circled {
                display: block;
                margin: 0 auto;
                margin-top: 35px;
                width: 60%;
                box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
                border-radius: 100%;
                & .logo-image {
                    border-radius: 100%;
                }
            }
            & .details-container {
                padding: 15px;
                & .title {
                    font-size: 1.4em;
                    font-weight: bold;
                    margin: 0;
                    color: #383C3E;
                    margin-bottom: 10px;
                }
                & .item-details {
                    color: #383C3E;
                    margin: 0;
                }
                & .map-container {
                    position: relative;
                    width: 100%;
                    background-color: #efefef;
                    padding-top: 100%;
                    border-radius: 6px;
                    border: 1px solid #E5E5E5;
                    & .map-iframe {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }                
            }
            & .footer {
                & .title {
                    color: #383C3E;
                    font-size: 1em;
                    margin: 0;
                    margin-bottom: 15px;
                }
                & .control-group {
                    display: flex;
                    & .control {
                        width: 100%;
                        & .input-control {
                            width: 100%;
                            height: 40px;
                            padding: 15px;
                            border: none;
                            border-bottom: 1px solid #737B7D;
                        }
                    }
                    & .btn {
                        background-color: green;
                        &.btn-control {
                            padding: 0;
                            width: 50px;
                            height: 40px;
                            border-radius: 0;
                            color: #FFFFFF;
                            font-size: 1.2em;
                        }
                    }
                }
            }
        }
    }
    & .btn-send {
        background-color: #008F17 !important;
        font-weight: bold;
        width: 100%;
    }
  .header-modal {
    background-color: #2962ff;
    border-radius: 0;
  }
  .modal-button-custom {
    padding: 5px;
    width: 35px;
    height: 35px;
    border-radius: 20px;
    margin-top: 25px;
  }
  .button-group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 1.5em;
  }
  & .modal-card-body {
      & .columns {
          border-bottom: 1px solid #efefef;
          padding-top: 20px;
          padding-bottom: 20px;
      }
  }
`;
